import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppFacade } from '@app/app.facade';
import {
  LinkTypeEnum,
  OnboardingService,
  RouteStateEnum,
} from '@hohr/components';
import { ConfigService } from '@hohr/config';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomOnboardingService extends OnboardingService {
  appLanguage: string;
  defaultCountry = this.configService.config?.defaultCountry?.alpha2Code;

  constructor(
    private router: Router,
    public facade: AppFacade,
    private configService: ConfigService
  ) {
    super();
    this.appLanguage = this.facade.currentLanguageId;
  }

  registrationComplete() {
    combineLatest([
      this.facade.getUserProfile(),
      this.facade.getProfilePhoto(),
    ]).pipe(take(1)).subscribe();

    this.router.navigate(['my-cvs']);
  }

  // implement abstract function from extended service
  login(): void {}

  linkIdentity(type: LinkTypeEnum, value: string) {
    this.router.navigate(['consent', 'link-account'], {
      state: { mode: RouteStateEnum.link },
      queryParams: {
        type,
        value,
      },
    });
  }
}
